import React, { useState, useEffect } from "react";
//import "./App.css";
import { useForm } from "react-hook-form";
import { API } from '@aws-amplify/api';

export default function UserInfoForm() {

  const { 
    register, 
    handleSubmit, 
    getValues, 
    setValue,
    formState: { errors }, 
  } = useForm({
    mode: 'onBlur',
    defaultValues: {
      firstname: '',
      lastname: '',
      phone: ''
  }}); 

  const [userInfo, setUserInfo] = useState("");

  const onSubmit = (data) => {
    const payload = {
      firstname: data.firstname,
      lastname: data.lastname,
      phone: data.phone,
    };

    //Submission to AWS goes here
    console.log('submitpayload', data);
    const apiName = 'apic48d2c9b';
    const path = '/user';
    const myInit = {
      body: payload, // replace this with attributes you need
      headers: {} // OPTIONAL
    };
    API.post(apiName, path, myInit)
    .then((response) => {
      console.log(response);
      setValue('firstname', response[0].firstname);
      
    })
    .catch((error) => {
      console.log(error.response)
      alert(JSON.stringify(error));
    })
    }

  useEffect(() => {
    userInfoLoader();
  }, [setValue]);


  const userInfoLoader  = async () => {
    console.log("inside userInfoLoader");
    const apiName = 'apic48d2c9b' // was 'api60cb0321';
    const path = "/user" //+ ucs.customer.name.customer_id;
    const myInit = {
      headers: {'Content-Type':'application/json'}, 
      response: true
      };
      var response = await API.get(apiName, path, myInit);
    const myUserInfo =  await response.data;
    console.log('myUserInfo server side returned is ', myUserInfo);
    setUserInfo(myUserInfo);
  }
  
  return (
    <div
      className={"min-h-screen bg-no-repeat bg-cover bg-center"}
      style={{ backgroundImage: "url('https://picsum.photos/2000/2000')" }}
    >
      <div className={"flex justify-end"}>
        <div className={"bg-white min-h-screen w-1/2 flex justify-center items-center"}>
          <div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className={"mt-5"}>
                <input
                  className={"px-4 w-full border-2 py-2 rounded-md text-sm outline-none"}
                  value={getValues("firstname")}
                  {...register("firstname",{value: userInfo.firstname,  required: true })}
                  placeholder="First name"
                />
                {errors.name?.type === "required" && (<span>This field is required</span>)}
              </div>
              <div className={"mt-5"}>
                <input className={"px-4 w-full border-2 py-2 rounded-md text-sm outline-none"}
                  {...register("lastname", { required: true })}
                  placeholder="Last name"
                />
                {errors.name?.type === "required" && (
                  <span>This field is required</span>
                )}
              </div>

              <div className={"mt-5"}>
                <input
                  className={
                    "px-4 w-full border-2 py-2 rounded-md text-sm outline-none"
                  }
                  {...register("phone", { required: true })}
                  placeholder="phone"
                />
                {errors.message?.type === "required" && (
                  <span>This field is required</span>
                )}
              </div>
              <p>{userInfo}</p>
              <button
                className={
                  "mt-4 mb-3 w-full bg-green-500 hover:bg-green-400 text-white py-2 rounded-md transition duration-100"
                }
                type="submit"
              >
                Update your info
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}